export default "__VITE_ASSET__dQqf0_50__"